(function () {
    'use strict';
    vf.sprintshop = {
        settings: {
            target: '.mod-sprintshop',
            answers: {}
        },
        init: function (context) {

            var s = this.settings;
            var vresult = '';
            var matrix = {
                'JJJJ': 'teamleiter',
                'JJJN': '',
                'JJNJ': 'teamleiteranwaerter',
                'JJNN': '',
                'JNJJ': 'teamleiteranwaerter',
                'JNJN': '',
                'JNNJ': 'seniorberater',
                'JNNN': '',
                'NJJJ': 'teamleiteranwaerter',
                'NJJN': 'teamleiteranwaerter',
                'NJNJ': 'teamleiter',
                'NJNN': 'teamleiteranwaerter',
                'NNJJ': 'mentor',
                'NNJN': '',
                'NNNJ': 'juniorberater',
                'NNNN': ''
            };

            $(s.target, context).addBack(s.target).each(function () {

                var slider = $('.bxslider').bxSlider({
                    slideMargin: 10,
                    infiniteLoop: false,
                    touchEnabled: false,
                    hideControlOnEnd: true,
                    prevSelector: '.slider-prev',
                    prevText: 'Zur&uuml;ck'
                });

                $('.sprintshop-tile').on('click', function () {
                    var tileIndex = $(this).parent().data('tileindex');
                    $(this).parent().parent('.sprintshop-tiles-wrapper').find('.sprintshop-tile').removeClass('active');
                    $(this).addClass('active');
                    s.answers[slider.getCurrentSlide()] = tileIndex;
                    var result = '';

                    var humanIndex = 0;
                    $.each(s.answers, function (index, value) {
                        humanIndex = parseInt(index) + 1;
                        result += value;
                    });

                    vresult = matrix[result] || 'notification';

                    if (slider.getSlideCount() === humanIndex) {
                        $('.result-code').html(vresult);
                        $('.ws2-btn').attr('data-hash', vresult);
                        setTimeout(function () {
                            $('.sprintshop-result').fadeIn();
                        }, 500);
                    } else {
                        setTimeout(function () {
                            slider.goToNextSlide();
                        }, 500);
                    }
                    return false;
                });

                $('.ws2-btn').one('click', function() {

                    var tHash = $(this).attr('data-hash');

                    if ('notification' === vresult) {

                        $('.applicationNotification').animate({
                            height: 'toggle'
                        }, 500, function() {
                            $(this).show();
                            $('.applicationNotification').animate({
                                opacity: 1
                            }, 100 );
                        });

                    } else {

                        $('li[data-additional=' + tHash + ']').trigger('click');

                        var target = $('#result-tabs');
                        var heightNavigation = $('.main-nav').height();

                        $('html,body').animate({
                            scrollTop: target.offset().top - heightNavigation
                        }, 800);

                        var activeTab = $('.content .mod-tabs-nav > li.active');

                        var widthOfActiveTab = activeTab.width();
                        var indexOfActiveTab = activeTab.index();

                        $('.mod-tabs-nav').scrollLeft(widthOfActiveTab * indexOfActiveTab);
                    }
                });

            });
        }
    };
}(vf));
